import { CheckCircle2, ChefHat, Clock, UtensilsCrossed } from "lucide-react";

export const ORDER_STATUS_FLOW = [
  { key: "pending", label: "Pending", icon: Clock, next: "preparing", nextLabel: "Terima" },
  { key: "preparing", label: "Preparing", icon: ChefHat, next: "served", nextLabel: "Sajikan" },
  { key: "served", label: "Served", icon: UtensilsCrossed, next: "completed", nextLabel: "Selesaikan" },
  { key: "completed", label: "Completed", icon: CheckCircle2, next: null, nextLabel: "" },
];

export const ORDER_STATUS_META = {
  pending: { label: "Pending", badgeClass: "bg-warning/15 text-warning" },
  preparing: { label: "Preparing", badgeClass: "bg-primary/15 text-primary" },
  served: { label: "Served", badgeClass: "bg-success/15 text-success" },
  completed: { label: "Completed", badgeClass: "bg-muted text-muted-foreground" },
  cancelled: { label: "Cancelled", badgeClass: "bg-destructive/15 text-destructive" },
};

export function getNextOrderStatus(status) {
  return ORDER_STATUS_FLOW.find((step) => step.key === status)?.next || null;
}

export function getOrderStatusLabel(status) {
  return ORDER_STATUS_META[status]?.label || status;
}

export function getOrderStatusBadgeClass(status) {
  return ORDER_STATUS_META[status]?.badgeClass || "bg-muted text-muted-foreground";
}

export function getShortOrderNumber(orderNumber = "") {
  const [, shortNo] = orderNumber.split("-");
  return shortNo || orderNumber;
}
